import { useTranslation } from "react-i18next";

import { Typography } from "@aviary";
import { l } from "@shared/locales/i18n";

import * as styles from "./OrSection.styles";

const OrSection = () => {
  const { t } = useTranslation();

  return (
    <Typography type="footnote" isMarginless css={styles.orSection}>
      {t(l.magicLink.Or)}
    </Typography>
  );
};

export { OrSection };
